var _rect, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailydining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.207031,
    y: 0.194824,
    width: 100,
    height: 100,
    rx: 50,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.207,
    cy: 50.1948,
    r: 44.5,
    stroke: "#F6E003"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17363_86638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4475 51.6339C60.9232 50.0365 58.8768 49.1595 56.6947 49.1595C54.5126 49.1595 52.4663 50.0365 50.942 51.6339L50.493 52.0933L50.0441 51.6235C48.5197 50.0365 46.4734 49.1595 44.2913 49.1595C42.1092 49.1595 40.0524 50.0365 38.5385 51.6235C35.4377 54.8705 35.4377 60.1534 38.5385 63.4005L49 74.3735C49.3759 74.7703 49.8979 75 50.4408 75.0104C50.4617 75.0104 50.4721 75.0104 50.493 75.0104C51.0255 75.0104 51.5266 74.812 51.986 74.3735L62.4579 63.4109C65.5588 60.1639 65.5588 54.8809 62.4579 51.6339H62.4475ZM59.4615 60.5606L50.493 69.9467L41.5245 60.5502C39.9271 58.8692 39.9271 56.1442 41.5245 54.4737C42.2867 53.6803 43.2681 53.2313 44.2913 53.2313C45.3145 53.2313 46.3063 53.6698 47.0685 54.4737L49 56.4992C49.7831 57.324 51.0986 57.3554 51.986 56.4992L53.9071 54.4842C55.4314 52.8868 57.9372 52.8868 59.4615 54.4842C61.0589 56.1547 61.0589 58.8797 59.4615 60.5606Z",
    fill: "#F6E003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9985 43.8661V47.0818C58.314 47.1236 59.5773 47.4055 60.7467 47.9275V26.2737C60.7467 26.2737 60.2246 24.9999 58.6585 24.9999C57.0925 24.9999 53.3965 26.5034 53.3965 37.9045C53.3965 42.7698 56.9985 43.8661 56.9985 43.8661Z",
    fill: "#F6E003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6373 42.2478V47.7082H40.7835C41.8693 47.301 43.0282 47.0818 44.2289 47.0713V42.2478H47.3401C48.7496 42.2478 50.1591 41.1828 50.1591 39.8778V25.5742H46.5675V36.0774H44.2289V25.5742H40.6373V36.0774H38.2986V25.5742H34.707V39.8673C34.707 41.2246 36.127 42.2373 37.526 42.2373H40.6373V42.2478Z",
    fill: "#F6E003"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17363_86638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.0689,
    height: 50,
    fill: "white",
    transform: "translate(34.707 24.9999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailydining);
export default __webpack_public_path__ + "static/media/dailydining.318f26779bf1c4e4d36964345b247925.svg";
export { ForwardRef as ReactComponent };